import React from "react";
import { Button, Modal } from "semantic-ui-react";
import { ContactAvatar } from "../../../../../permits/components/ContactAvatar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNotifySubscriberContactMethodLink } from "../../../../hooks/useNotifySubscriberContactMethodLink";
import { faLink } from "@fortawesome/pro-solid-svg-icons";
import { useNotifySubscriberContactMethod } from "../../../../hooks/useNotifySubscriberContactMethod";
import { iconLookup } from "../utils/iconLookup";
import { buildIdentifierString } from "../utils/buildIdentifierString";

export function LinkSubscriberContactMethodModal({
  subscriberContactMethodId,
  person,
  isOpen,
  close,
}: {
  subscriberContactMethodId?: number;
  person: {
    userId: number;
    firstName: string;
    lastName: string;
  };
  isOpen: boolean;
  close: () => void;
}) {
  if (!subscriberContactMethodId) {
    return null;
  }

  const { linkSubscriberContactMethod, isLinkSubscriberContactMethodLoading } = useNotifySubscriberContactMethodLink();
  const { subscriberContactMethod, isSubscriberContactMethodLoading } = useNotifySubscriberContactMethod({
    id: subscriberContactMethodId,
  });

  const handleSubmit = () => async () => {
    await linkSubscriberContactMethod({
      subscriberContactMethodId,
      personId: person.userId,
    });
    close();
  };

  return (
    <Modal open={isOpen} onClose={close} closeIcon size='tiny'>
      <Modal.Header>Link Contact Method</Modal.Header>
      <Modal.Content>
        <div className='tw-mb-[10px] tw-flex tw-items-center tw-justify-around'>
          <div className='tw-flex tw-items-center tw-gap-2'>
            <ContactAvatar
              contact={{
                firstName: person.firstName,
                lastName: person.lastName,
                contactType: null,
                userId: person.userId,
              }}
            />
            <div>
              <span className='tw-tg-title-medium tw-truncate'>
                {person.firstName} {person.lastName}
              </span>
            </div>
          </div>
          <FontAwesomeIcon icon={faLink} className='tw-text-[16px]' />
          <span className='tw-tg-title-medium tw-flex tw-items-center tw-gap-1'>
            {iconLookup[subscriberContactMethod?.type || ""]?.()}
            {buildIdentifierString(subscriberContactMethod)}
          </span>
        </div>

        <span>
          After linking, the user will have to sign in with their email and password. They can no longer sign in
          anonymously using only their contact method.
        </span>
      </Modal.Content>
      <Modal.Actions>
        <Button content='Cancel' secondary onClick={close} />
        <Button
          content='Link Contact'
          primary
          onClick={handleSubmit()}
          disabled={isLinkSubscriberContactMethodLoading || isSubscriberContactMethodLoading}
        />
      </Modal.Actions>
    </Modal>
  );
}
